<template>
  <main>
    <div class="parallax-wrapper" v-css-parallax>
      <div class="parallax-bg" :style="'background-image: url(' + curr.cover + ')'"></div>
      <div class="parallax container-xxl " :style="'background-image: url(' + curr.cover + ')'"></div>
      <div class="heading-bg">
        <div class="container-sm">
          <h1 v-text="curr.title"></h1>
          <div v-text="curr.summary"></div>
        </div>
      </div>
    </div>
    <div class="page-content container-sm">
      <section class="py-3" v-html="curr.content"></section>

      <div class="pointing" hidden>
        <i class="iconfont icon-dot-arrow-down font-lg"></i>
      </div>

      <div class="bg-dark shadow mt-3">
        <div class="swiper-container faded" ref="sc">
          <div class="swiper-wrapper">
            <!--
            <div class="swiper-slide"
                 style="width: 45%; height: 15rem"
                 @click="slideTo(idx)"
                 :style="'background-image: url(' + img + ')'"
                 v-for="(img, idx) of imgs"></div>
            -->
            <div class="swiper-slide w-auto" v-for="(img, idx) of imgs" @click="slideTo(idx)">
              <img :src="img + '!mh.288'" alt="img">
            </div>

          </div>
          <div class="swiper-button-prev" @click="slidePrev" v-show="active !== 0"></div>
          <div class="swiper-button-next" @click="slideNext" v-show="active !== imgs.length - 1"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <div class="navigator font-sm py-5">
        <router-link :to="`/project/${prev.id}?dir=right`" v-if="prev">
          <i class="iconfont icon-dot-arrow-left mr-1"></i>
          <b>上一个作品</b>
        </router-link>
        <router-link class="mx-4" to="/projects">
          <i class="iconfont icon-grid"></i>
        </router-link>
        <router-link :to="`/project/${next.id}?dir=left`" v-if="next">
          <b>下一个作品</b>
          <i class="iconfont icon-dot-arrow-right ml-1"></i>
        </router-link>
      </div>
    </div>

    <LightBox :img="img" @close="img = null"/>
  </main>
</template>

<script>
import LightBox from './LightBox.vue'
import {resovleCover} from './scripts/functions'
import { http } from './http'
import Swiper from 'swiper'

// spotlight.js
// PhotoSwipe
let data

function fetch (to, from, next) {
  http.get('/chapter/' + to.params.id).then(function (res) {
    data = res
    next()
  })
}

export default {
  name: 'Project',
  components: {LightBox},
  beforeRouteUpdate: fetch,
  beforeRouteEnter: fetch,
  data () {
    return {
      active: 0,
      imgs: [],
      curr: {},
      prev: null,
      next: null,
      img: null,
    }
  },
  created () {
    var curr = data.curr,
        self = this
    if (curr.releaseAt) {
      curr.releaseAt = curr.releaseAt.split(' ')[0]
    }
    curr.cover = resovleCover(curr.cover)
    data.imgs = curr.pictures.split(',')
    data.curr = curr
    Object.assign(this, data)

    setTimeout(function () {
      self.swiper = new Swiper(self.$refs.sc, {
        pagination: {el: '.swiper-pagination', clickable: true, type: 'bullets',},
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        grabCursor: true,
        autoplay: true,
        speed: 650,
        on: {
          slideChange: function (s) {
            self.active = s.activeIndex
          }
        }
      })
    }, 200)
  },
  methods: {
    slideTo: function (idx) {
      if (idx === this.active) {
        this.img = this.imgs[idx]
        return
      }
      this.swiper.slideTo(idx)
    },
    slidePrev: function () {
      this.swiper.slidePrev()
    },
    slideNext: function () {
      this.swiper.slideNext()
    }
  }
}
</script>

<style>
.faded .swiper-slide:before {
  content: '';
  pointer-events: none;
  transition: all .3s ease-out;
  background: rgba(0, 0, 0, .55);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  left: 0;
  top: 0;
}
.faded .swiper-slide-active:before {
  background: transparent;
}
.faded .swiper-slide img {
  transition: all .3s ease-out;
  transform: scale(.8);
  height: 18rem
}
.faded .swiper-slide-active img {
  transform: scale(1);
}

</style>
